import { Theme } from "@twilio-paste/core/theme";
import React from "react";
import { useDarkMode } from "./shared/hooks/useDarkMode";
import { DarkModeContext } from "./shared/hooks/useDarkModeContext";

interface ProvidersProps {
    children: React.ReactNode;
}

const Providers = (props: ProvidersProps) => {
    const [theme, toggleMode, componentMounted] = useDarkMode();

    return (
        <Theme.Provider theme="default">
            <DarkModeContext.Provider value={{ theme, toggleMode, componentMounted }}>
                {props.children}
            </DarkModeContext.Provider>
        </Theme.Provider>
    );
};

export default Providers;
